<template>
  <v-menu bottom right offset-y offset-x>
    <template v-slot:activator="{ on }">
      <v-btn icon class="cv-btn" v-on="on" :title="$t('chat_menu_timer')">
        <v-icon v-bind:class="$store.state.currentChat.ttl > 0 ? activeClass : ''">{{$store.state.currentChat.ttl > 0 ? 'timer' : 'timer_off'}}</v-icon>
      </v-btn>
    </template>

    <v-list style="max-height: 350px; min-width: 180px; overflow-y: auto;">
      <template v-for="item in items">
        <v-list-tile
          :key="item.value"
          :class="item.selected"
          @click="clicked(item.value)"
        >
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title" />
          </v-list-tile-content>

        </v-list-tile>

      </template>
    </v-list>
  </v-menu>
</template>

<style>
.activeClass {
  color: var(--v-primary-base) !important;
}
</style>

<script>
  export default {
    name: 'time-selector',
    data: () => ({
      items: [],
      activeClass :"activeClass"
    }),
    props: {
      value: {
        type: Number,
        default: 0
      }
    },

    methods: {
      clicked(value) {
        console.log('selected:', value)
        this.$store.dispatch('updateCurrentTtl', value)
        this.$emit('update:value', value)
      },
      fetchItems() {
        let items = [
          { title: this.$t('off_title'), value: 0 },
          { title:'1 ' + this.$t('second'), value: 1 },
          { title:'3 ' + this.$t('seconds'), value: 3 },
          { title:'5 ' + this.$t('seconds'), value: 5 },
          { title:'10 ' + this.$t('seconds'), value: 10 },
          { title:'15 ' + this.$t('seconds'), value: 15 },
          { title:'30 ' + this.$t('seconds'), value: 30 },
          { title:'1 ' + this.$t('minute'), value: 60 },
          { title:'5 ' + this.$t('minutes'), value: 300 },
          { title:'1 ' + this.$t('hour'), value: 3600 },
          { title:'1 ' + this.$t('day'), value: 3600 * 24 },
          { title:'1 ' + this.$t('month'), value: 3600 * 24 * 30 },
          { title:'6 ' + this.$t('months'), value: 3600 * 24 * 30 * 6 },
          { title:'1 ' + this.$t('year'), value: 3600 * 24 * 365 },
        ]

        if (this.value < 1) {
          items.shift()
        }

        items.map(item => item.selected = (item.value == this.value) ? 'selection' : '')
        return items
      }
    },
    mounted() {
      this.items = this.fetchItems()
    },
    watch: {
      value: function(newValue, oldValue) {
        if (newValue != oldValue) {
          this.items = this.fetchItems()
        }
      }
    }
  }
</script>